// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"CardB1_TheComp___5Dv1"};